import { useEffect, useState } from 'react'

import { Input } from 'antd'
import { createStyles } from 'antd-style'

import { pick } from '@eastcoal/common/utils/object'

import { useImageCardStore } from '../Store/hooks/useStore'

const useStyles = createStyles(({ token }) => ({
  input: {
    display: 'block',
    textAlign: 'center',
    color: token.colorTextTertiary
  }
}))

export const ImageDesc = () => {
  const {
    isReverseSize,
    currentWidth,
    currentHeight,
    desc,
    setDesc,
    descInputVisible,
    toggleDescInputVisible
  } = useImageCardStore(state =>
    pick(state, [
      'isReverseSize',
      'currentWidth',
      'currentHeight',
      'desc',
      'setDesc',
      'descInputVisible',
      'toggleDescInputVisible'
    ])
  )

  const textareaWidth = isReverseSize() ? currentHeight : currentWidth

  const [value, setValue] = useState<string>()

  useEffect(() => {
    setValue(desc)
  }, [desc])

  const handleBlur = () => {
    setDesc(value)
    toggleDescInputVisible(false)
  }

  const { styles } = useStyles()

  return descInputVisible || !!desc ? (
    <Input.TextArea
      autoSize
      className={styles.input}
      placeholder='添加图片描述'
      value={value}
      variant='borderless'
      styles={{
        textarea: {
          width: textareaWidth
        }
      }}
      onBlur={handleBlur}
      onChange={e => setValue(e.target.value.trim())}
    />
  ) : null
}
